/* eslint-disable max-len */
import { usersList } from "./apiSlice";

export const deviceTemplateList=usersList.injectEndpoints({
    endpoints:(builder)=>({
        getDeviceList: builder.query({
            query: (queryParamsPassed) => `${queryParamsPassed?.isPatient===undefined?`devices?${queryParamsPassed?.searchparams}`:`patients/list-devices/${queryParamsPassed?.patientId}?${queryParamsPassed?.searchparams}`}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                
                'Device',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'Device', id:_id}))
            ]:[]
            
        }),

        // add device journey
        addDevice:builder.mutation({
            query:org=>({
                url:`devices/`,
                method:'POST',
                body:org
            }),
            invalidatesTags:['Device']
        }),

        // edit device  journey
        editDevice:builder.mutation({
            query:({id,body})=>({
                url:id!==undefined?`/devices/${id}`:`/devices/`,
                method:'PATCH',
                body:body
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'Device', id: arg.id },'Device']
        }),
        
        // view device  
        viewDevice: builder.query({    
            query: (id) => `devices/${id}`,
            providesTags: (result, error, arg) => [{ type: 'Device', id: arg }]    
        }),

        // get template name in dropdown
        getDeviceTemplateName: builder.query({
            query: (searchParams) => `devices/device-template-name?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                'Device',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'Device', id:_id}))
            ]:[]
            
        }),
        
        //  get template details (fetch details based on template name)
        getDeviceTemplateDetails: builder.query({    
            query: (id) => `devices/device-template/${id}`,
            providesTags: (result, error, arg) => [{ type: 'Device', id: arg }]    
        }),

        // delete device
        deleteDevice: builder.mutation({
            query: (body) => ({
                url: `devices/`,
                method: 'DELETE',
                body: body,
            }),
            invalidatesTags: (result, error, arg) => {
                // Invalidate tags if result is null (successful API call) and error is undefined
                return result === null && error === undefined
                    ? [{ type: 'Device', id: arg.device_id }, 'Device']
                    : [];
            },
        }),
        

        // export device
        exportDevices:builder.mutation({
            query: ({ sort, columns, dateformat, params }) => {
                const queryParams = Object.entries(params)
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
                return {
                    url: `devices/export-device?${queryParams}`,
                    method: 'POST',
                    body: { "columns": columns, "dateformat": dateformat ,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone }
                };
            },
        }),
        //update status
        deviceStatusChange:builder.mutation({
            query:({body})=>({
                url:`/devices/update-status`,
                method:'PATCH',
                body:body
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'Device', id: arg.id },'Device']
        }),
        getDeviceManufacture: builder.query({
            query: ()=>`devices/manufacturers`,  
        }),

    }),
    overrideExisting: false
})


export const {useGetDeviceTemplatesQuery,useGetDeviceTemplateNameQuery,useGetDeviceListQuery,useAddDeviceMutation, useViewDeviceQuery,useLazyViewDeviceQuery,useLazyGetDeviceTemplateDetailsQuery,useDeleteDeviceMutation,useEditDeviceMutation,useExportDevicesMutation,useDeviceStatusChangeMutation,useGetDeviceManufactureQuery}=deviceTemplateList